import React from 'react';

import { getLinks } from '@cache/index';
import { useIllustration } from '@utils/illustrations';
import Image from 'next/image';
import { useRouter } from 'next/router';

import Alert from '@ui/Alert';
import Box from '@ui/Box';
import Container from '@ui/Container';
import Button from '@ui/inputs/Button';
import Link from '@ui/link/Link';
import PageTitle from '@ui/PageTitle';
import Stack from '@ui/Stack';
import P from '@ui/staticpage/P';
import Subtitle from '@ui/staticpage/Subtitle';
import Typography from '@ui/Typography';

import useCms from '@components/Cms/useCms';
import PodcasterProfileLevelDetailLink from '@components/Podcaster/PodcasterProfileLevelDetailLink';
import useRegisterDialog from '@components/RegisterDialog/useRegisterDialog';
import useUser from '@components/User/useUser';

const PodcasterApplicationPage = () => {
    const cms = useCms();
    const { podcastProfile } = useIllustration();
    const { openRegisterDialog } = useRegisterDialog();
    const { user, hasPermissions, isAdmin, limits, userPodcasters } = useUser();
    const router = useRouter();

    const firstPodcasterId = userPodcasters[0]?.entityId;
    const showSecondaryCreateButton =
        user && userPodcasters.length < limits.maxPodcasterProfile && userPodcasters.length !== 0;

    const handleApplicationLink = () => {
        if (!user) {
            openRegisterDialog();
            return;
        }

        router.push(
            firstPodcasterId ? getLinks('podcasterProfile', firstPodcasterId) : getLinks('podcasterApplicationForm')
        );
    };

    const handleSecondaryProfileCreateClick = () => {
        router.push(getLinks('podcasterApplicationForm'));
    };

    return (
        <Container maxWidth="md" sx={{ p: 0 }}>
            <PageTitle>{cms[1062]}</PageTitle>
            {isAdmin && <Alert severity="warning">{cms[1109]}</Alert>}
            <Image src={podcastProfile} width={200} height={200} alt="" />
            <Subtitle>Csatlakozz te is az Atalon-hoz, mi díjazzuk előadói sikered!</Subtitle>
            <P>
                Amennyiben a sorozatodban szereplő Felhasználói tartalmak összesen legalább 200 hallgatótól legalább 500
                streamindítást értek el legalább 5 epizód feltöltése után, úgy sorozatonként 100.000 Ft (azaz százezer
                forint) + ÁFA egyszeri díjra vagy jogosult.
            </P>
            <P sx={{ mb: 2 }}>
                Amennyiben a sorozatodban szereplő Felhasználói tartalmak összesen legalább 500 hallgatótól legalább
                3000 streamindítást értek el legalább 8 epizód feltöltése után, úgy sorozatonként további 300.000 Ft
                (azaz háromszázezer forint) + ÁFA egyszeri díjra vagy jogosult.
            </P>
            <PodcasterProfileLevelDetailLink detailed />
            <Subtitle>Irányelveink</Subtitle>
            <P>
                Az Atalon elsődleges célja az informatív, szórakoztató tartalmak közzététele. Ezért azt javasoljuk, hogy
                tartózkodj:
            </P>
            <ul>
                <li>a túlságosan megosztó témáktól</li>
                <li>napi aktualitás megjelenítésétől</li>
                <li>a vallási és kisebbségek elleni uszítástól</li>
                <li>lehetőség szerint a politizálástól</li>
                <li>egyéb, nagyon megosztó témáktól (pl. oltás vs nem oltás)</li>
            </ul>

            <P>
                Minden esetben körültekintően kategorizáld be a tartalmadat! Ha bizonytalan vagy, inkább kapcsold be a
                18+-as szűrőt!
            </P>
            <P>A borítóképed esetén törekedj arra, hogy egységben legyen a podcasted szellemiségével.</P>
            <P>A leírás legyen rövid, változatos és informatív.</P>

            {/* <Image src={podcasterLevelsInfo} width={628} height={48} alt="" /> */}

            {!isAdmin && (
                <Stack mt={4} direction="row" spacing={2} alignItems="center">
                    <Button onClick={handleApplicationLink}>
                        {hasPermissions(['podcaster']) ? cms[1108] : cms[1063]}
                    </Button>
                    {showSecondaryCreateButton && (
                        <Button color="secondary" onClick={handleSecondaryProfileCreateClick}>
                            {cms[4021]}
                        </Button>
                    )}
                    <Link href={getLinks('podcasterFaq')} color="secondary">
                        {cms[1051]}
                    </Link>
                </Stack>
            )}

            <Box sx={{ borderTopWidth: 1, borderTopStyle: 'solid', borderColor: 'divider', mt: 4 }}>
                <Typography variant="body2" color="secondary" sx={{ textAlign: 'center', mt: 2 }}>
                    <Link href="https://assets.podpad.hu/legal/atmedia_aszf.pdf" target="_blank" color="secondary">
                        Általános szerződési feltételek
                    </Link>{' '}
                    |{' '}
                    <Link
                        href="https://assets.podpad.hu/legal/atmedia_adatkezeles.pdf"
                        target="_blank"
                        color="secondary"
                    >
                        Adatkezelési nyilatkozat
                    </Link>
                </Typography>
            </Box>
        </Container>
    );
};

export default PodcasterApplicationPage;
